export default {"src":"/_next/static/media/chevronUp_16.07fd9eb3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};